<template >
  <div class="page-layout">
    <el-aside class="nav-left">
      <Steper :data="steps" :current="current" />
    </el-aside>

    <div class="main-content">
      <router-view />
    </div>
  </div>
</template>
<script>
import Steper from '@/components/steper'
import { tencentADASteps, tencentV3Steps } from './data/steps.js'

export default {
  components: { Steper },
  data() {
    return {
      // current: 1
    }
  },
  computed: {
    routePath() {
      return this.$route.path
    },
    current() {
      if (this.routePath.includes('/creative')) return 1
      if (this.routePath.includes('/distribute')) return 2
      return 0
    },
    steps() {
      if (this.routePath.includes('tencentada')) return tencentADASteps
      return tencentV3Steps
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-left {
  background: #fff;
  box-shadow: 0px 2px 4px 0px #eff1fa;
  padding: 22px 15px;
  flex-basis: 200px;
}
.main-content {
  flex: auto;
  position: relative;
  overflow: auto;
  // max-width: calc(100vw - 200px);
}
</style>

<style lang="scss">
// 下一步提交按钮行
.submit-row {
  width: 100%;
  position: sticky;
  bottom: 0;
  z-index: 10;
  border: 1px solid #eaeaea;
  text-align: right;
  padding: 12px;
  background-color: #fff;
}
</style>
